

import React, { useEffect, useMemo, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
//import store from "store";
import styles from "./index.module.scss";
import { Form, Input } from "antd";
import commonRules from "components/Pages/User/common/rules";
import Dynamic, { type ExposeDynamicProps } from "@/components/App/Dynamic";
import useNextTick from "@/hooks/useNextTick";
import { axiosThrottle } from "@/utils/method";
import { waitRes } from "@/utils/axios";
import { get_faResult, get_getFaCheckItem } from "@/api/uaapi/user";
import NoEmail from "@/components/Xt/NoEmail";
import useAsyncEffect from "@/hooks/useAsyncEffect";
import { openLivehelp100Support } from "@/utils/livehelp100";
export interface FaItemProps {
  priority: number;
  msgType?: string;
  validateItemType: number;
}
export interface FaCheckProps {
  faCheckId: string;
  email?: string;
  mobile?: string;
  dynamicCodeType?: string;
  faItems: FaItemProps[];
  isAnswer?: number,
  countryCode?: string;
  faResultId?: string;
  faResetAuthId?: string;
}
type CopyFaCheckProps = FaCheckProps
export interface FaResultProps {
  faResultId: string;
}
interface SafeVerifyProps extends BaseCompProps {
  attr?: any;
  /**get_getFaCheckItem返回值 */
  faCheckData?: FaCheckProps;
  /**按钮文案*/
  btnText?: string;
  /**业务类型 */
  faBizType: number;
  /**是否显示安全项不可用按钮 */
  showLink?: boolean;
  /** Confirm 按钮上方插槽（如人机验证） */
  beforeConfirm?: React.ReactNode;
  /**dynamic code码 */
  dynamicCodeType?: string;
  verifyForm?: ObjAny;
  mt?: number;
  handleSuccessFn?(data: FaResultProps, formData: FormDataType): void;
}

const { useTranslation } = Hooks;
const { useForm } = Form;
const initFormData = {
  emailCode: "",
  mobileCode: "",
  googleCode: "",
};
type FormDataType = typeof initFormData & ObjAny;
const defaultFaCheckData = {};
const SafeVerify: React.FC<SafeVerifyProps> = ({
  className,
  faCheckData = defaultFaCheckData as FaCheckProps,
  btnText = "",
  faBizType,
  showLink = true,
  beforeConfirm,
  dynamicCodeType,
  verifyForm,
  mt,
  handleSuccessFn,
}) => {
  const t = useTranslation();
  const nextTick = useNextTick();
  const appCodeDynamicRef = useRef({} as ExposeDynamicProps);
  //const {isLogin} = store.user;
  const [formIns] = useForm();
  const [formData, setFormData] = useState({ ...initFormData } as FormDataType);
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [emailFa, setEmailFa] = useState(false);
  const [mobileFa, setMobileFa] = useState(false);
  const [googleFa, setGoogleFa] = useState(false);
  const [faItems, setFaItems] = useState<FaItemProps[]>([]);
  const [showmodal, setShowmodal] = useState(false);
  const [noEmailVisible, setNoEmailVisible] = useState(false);
  const [mobileMsgType, setMobileMsgType] = useState(0);
  const [backUrl] = useState(window.location.origin + window.location.pathname);
  const [copyFaCheckData, setCopyFaCheckData] = useState({} as CopyFaCheckProps);
  const [noEmailClickNumber, setNoEmailClickNumber] = useState(0);
  /**useEffect */
  useEffect(() => {
    formIns.setFieldsValue({ ...formData });
  }, [formData]);

  useAsyncEffect(async () => {
    let res = {} as FaCheckProps;
    if (faCheckData.faItems) {
      res = faCheckData;
    } else {
      const { data, err } = await waitRes(get_getFaCheckItem, { params: { faBizType }, errorPop: true });
      if (!err) {
        res = data;
      }
    }
    if (!res.dynamicCodeType) res.dynamicCodeType = dynamicCodeType;
    setFaItems(res.faItems);
    const emailFa = res.faItems?.some((faitem) => faitem.validateItemType == 0);
    const mobileFa = res.faItems?.some((faitem) => faitem.validateItemType == 1);
    const googleFa = res.faItems?.some((faitem) => faitem.validateItemType == 2);
    setEmailFa(emailFa);
    setMobileFa(mobileFa);
    setGoogleFa(googleFa);
    setEmail(res.email || "");
    setMobile(res.mobile || "");
    setCopyFaCheckData({ ...res });
  }, [faCheckData]);

  /**useMemo */
  const disabledForm = useMemo(() => {
    const mapCode = {
      emailCode: emailFa,
      mobileCode: mobileFa,
      googleCode: googleFa,
    };

    const codeFlag = Object.keys(formData)
      .filter((k) => !!mapCode[k])
      .some((k1) => formData[k1] == "");
    const formFlag = verifyForm ? Object.keys(verifyForm).some(key => !verifyForm[key]) : false;
    return codeFlag || formFlag;
  }, [formData, emailFa, mobileFa, googleFa, verifyForm]);
  /**method */
  const valuesChange = (changedValues: FormDataType, allValues: FormDataType) => {
    const data = { ...formData, ...changedValues };
    setFormData(data);
  };

  const noEmailChange = () => {
    if (noEmailClickNumber) {
      setNoEmailVisible(true);
    }
    setNoEmailClickNumber(1);
  };

  const submitForm = axiosThrottle(async (unlock) => {
    const { data, err } = await waitRes(get_faResult, {
      errorPop: true,
      params: {
        ...formData,
        faBizType,
        faCheckId: copyFaCheckData.faCheckId,
      },
    });
    if (err) return;
    handleSuccessFn && handleSuccessFn(data as FaResultProps, formData);
    formIns.setFieldsValue({ ...initFormData })
    setFormData({ ...initFormData })
    unlock();
  });
  return (
    <div className={cx(className, styles["safe-verify-ctn"], styles["account_container"])}>
      <Form name="safeVerifyForm" initialValues={formData} form={formIns} onValuesChange={valuesChange} layout="vertical">
        {emailFa && (
          <Form.Item name="emailCode" label={t("google.gmail", { email: email.replace(/(\w{2}).*(\w{1})@(.*)/, "$1***@$3") })} rules={commonRules.emailCode}>
            <Input
              maxLength={6}
              allowClear
              className={styles["common_form_input"]}
              autoComplete="off"
              suffix={
                <div className={styles["forget_password"]}>
                  <Dynamic
                    FaValidTypeDict={'EMAIL'}
                    faCheckId={copyFaCheckData.faCheckId}
                    msgType={2}
                    codeType={copyFaCheckData.dynamicCodeType} noEmailChange={noEmailChange} />
                </div>
              }
            />
          </Form.Item>
        )}
        {email && noEmailVisible && (
          <div className={cx(styles["text2"], styles["no_email"])} onClick={() => setShowmodal(true)}>
            {t("google.noEmail")}
          </div>
        )}
        {mobileFa && (
          <Form.Item name="mobileCode" label={t("google.mobile", {
            mobile: mobile.length > 7
              ? mobile.replace(/(\d{3})\d*(\d{4})/, "$1***$2")
              : mobile.replace(/(\d{2})\d*(\d{2})/, "$1***$2"),
          })} rules={commonRules.mobileCode}>
            <Input
              maxLength={6}
              allowClear
              className={styles["common_form_input"]}
              autoComplete="new-text"
              suffix={
                <div className={styles["forget_password"]}>
                  <Dynamic
                    ref={appCodeDynamicRef}
                    FaValidTypeDict={'MOBILE'}
                    msgType={mobileMsgType}
                    faCheckId={copyFaCheckData.faCheckId}
                    codeType={copyFaCheckData.dynamicCodeType}
                    onClick={() => {
                      setMobileMsgType(0);
                    }}
                  />
                </div>
              }
            />
          </Form.Item>
        )}

        {/* 语音验证码功能已注释 */}
        {/* {mobileFa && (
          <div className={cx(styles["voice"], !mt && styles["mt12"])}>
            <span onClick={() => { setMobileMsgType(1); nextTick(() => appCodeDynamicRef.current.handleClick(true)); }}>
              {t("2fa.voiceCode")}
            </span>
          </div>
        )} */}
        {googleFa && (
          <Form.Item name="googleCode" label={t("account.AuthenticationCode")} rules={commonRules.googleCode}>
            <Input maxLength={6} allowClear className={styles["common_form_input"]} autoComplete="new-text" />
          </Form.Item>
        )}
      </Form>

      {faItems?.length && showLink && (
        <>
          {/* 原：Next Link → /accounts/user/reset-verification */}
          {/* <Link href={{ pathname: "/accounts/user/reset-verification", search: `faCheckId=${copyFaCheckData.faCheckId}&backUrl=${backUrl}` }}>
            <div className={styles["text2"]}>{t("google.security")}</div>
          </Link> */}
          <div
            className={styles["text2"]}
            role="button"
            tabIndex={0}
            onClick={() => openLivehelp100Support()}
            onKeyDown={(e) => e.key === "Enter" && openLivehelp100Support()}
          >
            {t("google.security")}
          </div>
        </>
      )}
      {beforeConfirm}
      {(emailFa || mobileFa || googleFa) && (
        <div className={cx(styles["base-btn"], disabledForm && styles["disabledBtn"])} onClick={submitForm}>
          {btnText || t("account.confirm")}
        </div>
      )}
      <NoEmail open={showmodal} changeOpen={() => setShowmodal(false)} email={copyFaCheckData.email} />
    </div>
  );
};
export default observer(SafeVerify);
